<template>
  <div class="gam-chessboard-promotion" @click.stop>
    <button
      v-for="option in promotionOptions"
      :key="option.piece"
      class="promotion-option"
      @click="$emit('select', option.piece)"
    >
      <img :src="option.src" :alt="option.piece" class="promotion-icon" draggable="false" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  color: 'w' | 'b';
}>();

defineEmits<{
  select: [piece: string];
}>();

const WHITE_PIECES: Record<string, string> = {
  q: new URL('../../../ui/icons/chess/queen-white.svg', import.meta.url).href,
  r: new URL('../../../ui/icons/chess/rook-white.svg', import.meta.url).href,
  b: new URL('../../../ui/icons/chess/bishop-white.svg', import.meta.url).href,
  n: new URL('../../../ui/icons/chess/knight-white.svg', import.meta.url).href,
};

const BLACK_PIECES: Record<string, string> = {
  q: new URL('../../../ui/icons/chess/queen-black.svg', import.meta.url).href,
  r: new URL('../../../ui/icons/chess/rook-black.svg', import.meta.url).href,
  b: new URL('../../../ui/icons/chess/bishop-black.svg', import.meta.url).href,
  n: new URL('../../../ui/icons/chess/knight-black.svg', import.meta.url).href,
};

const promotionOptions = computed(() => {
  const pieces = props.color === 'w' ? WHITE_PIECES : BLACK_PIECES;
  return Object.entries(pieces).map(([piece, src]) => ({ piece, src }));
});
</script>

<style lang="scss" scoped>
@use '@/ui/css/mixins' as *;
.gam-chessboard-promotion {
  display: flex;
  flex-direction: column;
  background: var(--color-dark-600);
  border-radius: var(--radius-x-small);
  overflow: hidden;
  box-shadow: var(--shadow-card-hover);
  z-index: 10;
}

.promotion-option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  transition: background var(--transition) var(--cubic-bezier);

  @include hover {
    background: var(--color-white-10);
  }
}

.promotion-icon {
  width: 70%;
  height: 70%;
  object-fit: contain;
  pointer-events: none;
  filter: none;
}
</style>
